export function accordionWithCircleVisuals() {
	// console.log('accordionWithCircleVisuals invoked.');

	const axes = [...document.querySelectorAll('.axis')];

	let rotation = 180; // change it to adjust the initial position of buttons

	function updateVisibleElements(element) {
		const currentIndex = Array.from(axes).indexOf(element);
		const previousSiblingIndex = currentIndex === 0 ? axes.length - 1 : currentIndex - 1;
		const nextSiblingIndex = currentIndex === axes.length - 1 ? 0 : currentIndex + 1;

		axes.forEach((axis, i) => {
			if (i === previousSiblingIndex || i === currentIndex || i === nextSiblingIndex) {
				axis.classList.add('is-visible');

				if (i === currentIndex) {
					axis.classList.add('in-focus');
				} else {
					axis.classList.remove('in-focus');
				}
			} else {
				axis.classList.remove('is-visible');
				axis.classList.remove('in-focus');
			}
		});
	}

	function updateMenuRotation(deg) {
		document
			.querySelector('.circle-menu')
			.style.setProperty('--menu-rotation', `${deg}deg`);
	}

	function rotateMenu(steps) {
		rotation += (360 * steps) / axes.length;
		updateMenuRotation(rotation);
	}

	function minStepsToTop(aR, mR, aL) {
		const totalSteps = Math.round(((((mR + 360) % 360) + 180 + aR) * aL) / 360);
		const maxAbsoluteSteps = Math.floor(aL / 2);
		return -(((totalSteps + maxAbsoluteSteps + aL) % aL) - maxAbsoluteSteps);
	}

	function getRotation(type, target) {
		return +getComputedStyle(target)
			.getPropertyValue(`--${type}-rotation`)
			.replace('deg', '');
	}

	function rotateToTop(e) {
		const button = e.target;
		const directParent = button.parentNode;

		if (button) {
			// Remove 'active' class from all elements and add it to the button.
			[...document.querySelectorAll('.em-accordion-circle .axis > .active')].forEach((el) => el.classList.remove('active'));
			button.classList.add('active');

			// Calculate previous and next sibling indices considering circular navigation.
			updateVisibleElements(directParent);

			rotateMenu(
				minStepsToTop(
					getRotation('axis', button),
					getRotation('menu', button),
					axes.length,
				),
			);
		}
	}

	// adds the 'in-focus' class to the first element and additional css class to next and last element.
	if (axes.length > 0) {
		updateVisibleElements(axes[0]);
	}

	updateMenuRotation(rotation);

	axes.forEach((axis, i) => {
		const angle = (360 * i) / axes.length;
		axis.style.setProperty('--axis-rotation', `${angle}deg`);
		axis.querySelector('div').addEventListener('click', rotateToTop);
	});

	//  Logic related to block emagine/accordion, that should trigger the rotation.
	const navItems = [...document.querySelectorAll('.em-accordion-circle .em-accordion__control')];

	function handleClick(index) {
		navItems.forEach((navItem) => {
			navItem.classList.remove('active');
		});

		navItems[index].classList.add('active');

		axes[index].querySelector('div').click();
	}

	navItems.forEach((navItem, i) => {
		navItem.addEventListener('click', () => {
			// console.log('navItem clicked:', i);
			handleClick(i);
		});
	});
}

// Invoke the function.
accordionWithCircleVisuals();
